import apiFetch from '../../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'dossier', method: 'POST', body: body, token: token })
}
